import {
  SubscriptionPreviewItemResponse,
  SubscriptionPreviewResponse,
} from '../../Interfaces/api/backoffice/subscription.interface';

export class SubscriptionPreview {
  plan_id = '';
  plan_code: string | null = null;
  offer_type = '';
  proration_behavior = '';
  amount_due_now: number | null = null;
  next_invoice_total: number | null = null;
  currency = '';
  items: SubscriptionPreviewItemResponse[] = [];

  constructor(data: Partial<SubscriptionPreviewResponse> = {}) {
    Object.assign(this, data);
  }

  get chargesNow(): boolean {
    return (this.amount_due_now ?? 0) > 0;
  }

  get removedItemCount(): number {
    return this.items.filter((item) => item.deleted === true).length;
  }

  matches(planId: string, offerType: string): boolean {
    return this.plan_id === planId && this.offer_type === offerType;
  }
}
